import { webhookApi } from '@api/webhook/webhook.api';

export const {
  useLazyLoadWebhookQuery,
  useDeleteWebhookMutation,
  useAddWebhookMutation,
  useUpdateWebhookMutation,
  useTriggerEventMutation,
} = webhookApi;
